// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input{transition:border .2s ease-in-out;min-width:280px}.input.filled+.label,.input:active+.label,.input:focus+.label{font-size:.75rem;transition:all .2s ease-out;top:-.1rem;color:#667eea}.label{transition:all .2s ease-out;top:.4rem;left:0}", ""]);
// Exports
module.exports = exports;
